<div class="notification-detail-page">
  @if (isLoading()) {
    <zag-loading-state [message]="'common.loading' | translate" />
  } @else if (error()) {
    <zag-error-state [message]="error()! | translate" [backLink]="'/notifications'" [backText]="'notifications.title' | translate" />
  } @else if (notification(); as n) {
    <zag-entity-detail-layout>
      <!-- ── Sidebar ──────────────────────────────────────────────── -->
      <div slot="sidebar">
        <zag-profile-summary-card
          [avatarIcon]="typeIcon()"
          [avatarIconColor]="typeIconColor()"
          [avatarBadge]="categoryBadge()"
          [avatarName]="n.title | translate: translateParams()"
          [subtitle]="'notifications.types.' + n.type | translate"
          [stats]="profileStats()"
          [quickActionsTitle]="'common.quickActions' | translate"
          [quickActions]="quickActions()"
          [dangerActions]="dangerActions()"
          [dangerZoneTitle]="'common.dangerZone' | translate"
          (quickActionClick)="onQuickAction($event)"
          (dangerActionClick)="onDangerAction($event)"
        />
      </div>

      <!-- ── Main content ─────────────────────────────────────────── -->
      <div slot="content">
        <zag-accordion>
          <!-- Message section -->
          <zag-accordion-item [title]="'notifications.detail.messageSection' | translate" icon="chat_bubble_outline" [expanded]="true">
            <div class="notification-detail-page__message-card">
              <div class="notification-detail-page__message-header">
                <div class="notification-detail-page__message-icon-wrap" [class]="'notification-detail-page__message-icon-wrap--' + n.type">
                  <span [zagIcon]="typeIcon()" class="notification-detail-page__message-icon"></span>
                </div>
                <div class="notification-detail-page__message-meta">
                  <strong class="notification-detail-page__message-title">{{ n.title | translate: translateParams() }}</strong>
                  <time class="notification-detail-page__message-time" [attr.datetime]="n.createdAt">{{ formatDate(n.createdAt) }}</time>
                </div>
                <!-- Priority badge (only when not normal) -->
                @if (n.priority !== 'normal') {
                  <span class="notification-detail-page__badge notification-detail-page__badge--priority-{{ n.priority }}">
                    {{ 'notifications.priorities.' + n.priority | translate }}
                  </span>
                }
              </div>
              <p class="notification-detail-page__message">{{ n.message | translate: translateParams() }}</p>
            </div>
          </zag-accordion-item>

          <!-- Delivery status section -->
          @if (deliveries().length > 0) {
            <zag-accordion-item [title]="'notifications.detail.deliveriesSection' | translate" icon="local_shipping" [expanded]="true">
              <div class="notification-detail-page__deliveries">
                @for (delivery of deliveries(); track delivery.id) {
                  <div class="notification-detail-page__delivery-item">
                    <div class="notification-detail-page__delivery-header">
                      <span class="notification-detail-page__delivery-channel">
                        <span [zagIcon]="delivery.channel === 'in_app' ? 'notifications' : 'webhook'"></span>
                        {{ 'notifications.channels.' + delivery.channel | translate }}
                      </span>
                      <span
                        class="notification-detail-page__delivery-status notification-detail-page__delivery-status--{{ delivery.status }}"
                      >
                        {{ 'notifications.deliveryStatus.' + delivery.status | translate }}
                      </span>
                      @if (delivery.status === 'failed') {
                        <button zagButton type="button" (click)="onRetryDelivery(delivery.id)">
                          <span zagIcon="refresh"></span>
                          {{ 'notifications.retry' | translate }}
                        </button>
                      }
                    </div>
                    @if (delivery.errorMessage) {
                      <p class="notification-detail-page__delivery-error">{{ delivery.errorMessage }}</p>
                    }
                    <p class="notification-detail-page__delivery-meta">
                      {{ delivery.attemptCount }}/{{ delivery.maxAttempts }}
                      @if (delivery.deliveredAt) {
                        · {{ formatDate(delivery.deliveredAt) }}
                      }
                    </p>
                  </div>
                }
              </div>
            </zag-accordion-item>
          }

          <!-- Metadata section (only when metadata is present) -->
          @if (n.metadata) {
            <zag-accordion-item [title]="'notifications.detail.metadataSection' | translate" icon="data_object" [expanded]="false">
              <pre class="notification-detail-page__metadata-json">{{ n.metadata | json }}</pre>
            </zag-accordion-item>
          }
        </zag-accordion>
      </div>
    </zag-entity-detail-layout>
  }
</div>
